export default __webpack_public_path__ + "static/media/sms.48b20b1a.svg";